import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const icon: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: (p) => p.palette.grey[500],
  backgroundColor: (p) => p.palette.grey[100],
  padding: (p) => p.spacing(1),
  borderRadius: (p) => p.spacing(0.5),
  cursor: 'pointer',
};
